<template>
	<v-container class="mx-auto">
		<v-row class="main-content-container mx-auto" v-if="course">
			<v-col class="mb-4 col-lg-8 col-12">
				<v-card class="mx-auto" max-width="100%">
					<div v-if="course.video_id">
						<iframe
							type="text/html"
							width="100%"
							height="422"
							:src="
								`https://www.youtube.com/embed/${course.video_id}?autoplay=1`
							"
							allowfullscreen="1"
							mozallowfullscreen="1"
							msallowfullscreen="1"
							oallowfullscreen="1"
							webkitallowfullscreen="1"
							frameborder="0"
						></iframe>
					</div>
					<div class="px-4">
						<v-card-title>{{ course.name }}</v-card-title>

						<v-col
							v-for="(section, index) in course.body"
							:key="index"
							:ref="`section-${index}`"
							class="pl-0"
						>
							<v-card-text
								class="text--primary line-breaks"
								v-if="section.type == 'TEXT'"
								>{{ section.content }}</v-card-text
							>

							<template v-if="section.type == 'LIST'">
								<ul class="no-bullet-point">
									<div v-for="(item, index) in section.content" :key="index">
										<li>
											<v-row class="py-2">
												<v-col class="col-1 pa-0" style="max-width: 40px">
													<v-icon class="mr-2 float-left"
														>mdi-chevron-right</v-icon
													>
												</v-col>
												<v-col class="pa-0">
													<v-card-text class="pa-0">
														<span class="inner-li">{{ item }}</span>
													</v-card-text>
												</v-col>
											</v-row>
										</li>
									</div>
								</ul>
							</template>

							<template v-if="section.type == 'IMAGE'">
								<v-img
									width="500"
									class="mx-auto rounded py-3"
									:src="section.content"
									contain
									transition="fade"
								></v-img>
							</template>
						</v-col>

						<v-card-actions class="justify-end">
							<v-btn
								class="mt-2 text-capitalize"
								:color="theme.primary"
								@click="goUp"
								width="120"
								depressed
								text
							>
								<v-icon class="mr-2">mdi-chevron-up</v-icon>
								Go up
							</v-btn>
						</v-card-actions>
					</div>
				</v-card>
			</v-col>
			<v-col class="mb-4 col-md-4">
				<v-card class="mx-auto" max-width="100%">
					<v-card-title class="font-normal">{{
						course.school.name
					}}</v-card-title>

					<v-card-subtitle class="pb-0 pt-1 font-small"
						>Last updated {{ formatDate(course.updated_at) }}</v-card-subtitle
					>

					<v-card-subtitle class="font-small">{{
						`Grade ${course.grade} • Level ${course.difficulty}`
					}}</v-card-subtitle>

					<v-row>
						<v-col class="col-md-5 text-center">
							<v-chip class="duration ml-5">
								<v-icon id="icon">mdi-alarm</v-icon>
								<span class="ml-3">
									{{ formatDuration(course.duration) }}
								</span>
							</v-chip>
						</v-col>
						<v-col class="col-md-7 text-center">
							<v-chip class="subject">
								<v-icon
									id="icon"
									:style="{
										color: `${course.subject.color} !important`,
									}"
									>mdi-label</v-icon
								>
								<span
									class="ml-3"
									:style="{
										color: `${course.subject.color} !important`,
									}"
								>
									{{ course.subject.name }}
								</span>
							</v-chip>
						</v-col>
					</v-row>
					<template>
						<v-stepper :value="step_value" vertical>
							<v-stepper-items>
								<div v-for="(section, index) in course.body" :key="index">
									<v-stepper-step
										class="font-small stepper"
										:step="index + 1"
										v-if="section.type == 'TEXT'"
										@click="goToSection(index)"
									>
										<span class="truncated-text font-small">{{
											section.content
										}}</span>
									</v-stepper-step>
									<v-stepper-step
										class="font-small stepper"
										:step="index + 1"
										v-if="section.type == 'LIST'"
										@click="goToSection(index)"
									>
										<span class="truncated-text font-small">{{
											section.content[0]
										}}</span>
									</v-stepper-step>
								</div>
							</v-stepper-items>
						</v-stepper>
					</template>

					<v-card-text class="text--success" v-if="course.has_completed">
						<div>
							You have completed this course on
							{{ formatDate(course.completed_at) }}
						</div>
					</v-card-text>

					<v-card-actions class="mx-auto">
						<v-btn
							class="white--text mt-2 text-capitalize"
							:color="course.has_completed ? 'red' : theme.primary"
							@click="toggleComplete"
							width="100%"
							depressed
						>
							<v-icon class="mr-2" v-if="course.has_completed"
								>mdi-close</v-icon
							>
							<v-icon class="mr-2" v-else>mdi-check</v-icon>
							<template v-if="course.has_completed"
								>Mark as Incomplete</template
							>
							<template v-else>Mark as complete</template>
						</v-btn>
					</v-card-actions>
				</v-card>
			</v-col>
		</v-row>
	</v-container>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'
export default {
	name: 'Course',

	data: () => ({
		course: null,
	}),

	methods: {
		...mapMutations(['setAlert', 'setUser']),
		goToSection(index) {
			this.$nextTick(() => {
				this.$refs[`section-${index}`][0].scrollIntoView({ behavior: 'smooth' })
			})
		},
		formatDate(date) {
			return this.core.moment(date).format('llll')
		},
		formatDuration(duration) {
			return this.core.moment
				.utc(this.core.moment.duration(duration, 'minutes').asMilliseconds())
				.format('HH[h] mm[m]')
		},
		toggleComplete() {
			this.core.http
				.post(`course/${this.$route.params.id}/complete`)
				.then(response => {
					this.setAlert(response)
					this.course = response.data.course
					this.setUser(response.data.user)
					if (this.course.has_completed) {
						setTimeout(() => {
							this.$router.push({ name: 'Dashboard' })
						}, 1000)
					}
				})
				.catch(error => {
					this.setAlert(error.response)
				})
		},
		goUp() {
			window.scrollTo({
				top: 0,
				left: 0,
				behavior: 'smooth',
			})
		},
	},

	mounted() {
		this.core.http
			.get(`course/${this.$route.params.id}`)
			.then(response => {
				this.course = response.data.course
			})
			.catch(error => {
				this.setAlert(error.response)
			})
	},

	computed: {
		...mapGetters(['theme', 'user']),
		step_value: function() {
			return 0
		},
	},
}
</script>
